import { WhereClausePreview } from '@modules/common/components/WhereClausePreview';
import { isEmptyWhereClause } from '@modules/common/utils';
import { CompareFieldGroupWrapper } from '@modules/quantify/components/CompareFieldGroupWrapper';
import {
  DEFAULT_COMPARE_FILTER_A_NAME,
  DEFAULT_COMPARE_FILTER_B_NAME,
} from '@modules/quantify/constants';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Stack, Typography } from '@mui/material';

export const CompareByFiltersPreview = () => {
  const whereClause = useQuantifyStore(
    ({ query }) => query.whereClauseConfig?.whereClause,
  );
  const compareTo = useQuantifyStore(({ query }) => query.compareTo);

  const compareFilterAName = useQuantifyStore(
    ({ metadata }) =>
      metadata.compareQBField.compareQBFieldAName ||
      DEFAULT_COMPARE_FILTER_A_NAME,
  );
  const compareFilterBName = useQuantifyStore(
    ({ metadata }) =>
      metadata.compareQBField.compareQBFieldBName ||
      DEFAULT_COMPARE_FILTER_B_NAME,
  );

  if (compareTo?.type !== 'whereClause') {
    return null;
  }

  const isFilterAPresent = !!whereClause && !isEmptyWhereClause(whereClause);
  const isFilterBPresent =
    !!compareTo?.whereClause && !isEmptyWhereClause(compareTo?.whereClause);

  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="subtitle1">Compare by Filters</Typography>
        <Typography variant="caption" color="text.secondary">
          (A - B)
        </Typography>
      </Stack>
      <CompareFieldGroupWrapper
        relationIndicatorSx={{
          mt: 0.2,
        }}
        fieldA={
          <Stack spacing={1} pb={1}>
            <Typography variant="body2">{compareFilterAName}</Typography>
            {isFilterAPresent ? (
              <WhereClausePreview whereClause={whereClause} />
            ) : (
              <Typography variant="body2" color="text.secondary">
                No {compareFilterAName} applied
              </Typography>
            )}
          </Stack>
        }
        fieldB={
          <Stack spacing={1}>
            <Typography variant="body2">{compareFilterBName}</Typography>
            {isFilterBPresent ? (
              <WhereClausePreview whereClause={compareTo.whereClause} />
            ) : (
              <Typography variant="body2" color="text.secondary">
                No {compareFilterBName} applied
              </Typography>
            )}
          </Stack>
        }
      />
    </Stack>
  );
};
